// extracted by mini-css-extract-plugin
export default {"main":"ChartInfo_main__il2XS","even":"ChartInfo_even__yMqk4","odd":"ChartInfo_odd__4f6Ov","body":"ChartInfo_body__A1+UQ","title1":"ChartInfo_title1__--HiJ"};